import {ApplicationStoreType} from 'desktop/store';

import {MODULE_KEY_CHECKOUT} from '../constants';

/**
 * Get is checkout loading
 * @param {ApplicationStoreType} store - current store
 * @return {boolean} is loading
 */
export const getIsCheckoutLoading = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_CHECKOUT].checkout.isLoading;

/**
 * get shipping address phone number
 */
export const getShippingPhoneNumber = (store: ApplicationStoreType) =>
    store[MODULE_KEY_CHECKOUT].deliveryStep.shippingAddress.phone.value;

/**
 * get shipping address phone number
 */
export const getShippingEmail = (store: ApplicationStoreType) =>
    store[MODULE_KEY_CHECKOUT].deliveryStep.shippingAddress.email.value;
